import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileCancelButton from "../button/mobileCancelButton";
import {getDataFromList} from "../../../utils/mobileUtils";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingFromList extends MobileRecording {
    constructor(props) {
        super();
    }

    state = {
        searchText: ""
    };

    setTableFields = (dbId, paramValue, paramDisplayValue) => {

        const {currentRecordingFlowChart, setRecordDataFieldAndDbId} = this.props;
        const {valueField, displayValueField} = this;

        if (valueField === null) return;

        let value = "";
        let displayValue = "";

        value = paramValue;
        if (displayValueField === null)
            displayValue = paramValue;
        else
            displayValue =
                paramDisplayValue;

        setRecordDataFieldAndDbId(
            currentRecordingFlowChart.dbIdTableField,
            dbId,
            currentRecordingFlowChart.tableField,
            value,
            displayValue
        );

    }

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                const {currentRecordingFlowChart} = this.props;
                const {valueField, displayValueField} = this;

                if (valueField === null) return;

                // let value = "";
                // let displayValue = "";
                //
                // value = rowInfo.original[currentRecordingFlowChart.valueField];
                // if (displayValueField === null)
                //     displayValue = rowInfo.original[currentRecordingFlowChart.valueField];
                // else
                //     displayValue =
                //         rowInfo.original[currentRecordingFlowChart.displayValueField];
                //
                // setRecordDataField(
                //     currentRecordingFlowChart.tableField,
                //     value,
                //     displayValue
                // );

                this.setTableFields(
                    rowInfo.original["dbId"],
                    rowInfo.original[currentRecordingFlowChart.valueField],
                    rowInfo.original[currentRecordingFlowChart.displayValueField]
                )

                this.onFieldContinue();
            }
        };
    };

    handleChange = ({currentTarget: input}) => {
        const searchText = input.value;
        this.setState({searchText});
    };

    render = () => {
        const {
            flowChart,
            currentFlowChart,
            currentRecordingFlowChart
        } = this.props;
        const {searchText} = this.state;

        const list = getDataFromList(flowChart, currentRecordingFlowChart);

        let data = [];
        let columns = [
            {
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={currentRecordingFlowChart.title.text}
                        searchable={currentRecordingFlowChart.searchable}
                        searchHandler={this.handleChange}
                        value={searchText}
                    />
                ),
                columns: []
            }
        ];
        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        let fieldCounter = 0;
        let fields = [];
        for (const listedFieldItem of currentRecordingFlowChart.listedFields) {
            let column = {
                Header: listedFieldItem.title.text,
                accessor: listedFieldItem.fieldName
            };
            if (fieldCounter++ === 0) {
                column["Footer"] = () => (
                    <div className="text-left">
                        <MobileCancelButton
                            onClick={() => {
                                this.onFieldCancel();
                            }}
                            title={{text: "Abbr."}}
                        />
                    </div>
                );
            }
            columns[0].columns.push(column);
            fields.push(listedFieldItem.fieldName);
        }
        for (const hiddenFieldItem of currentRecordingFlowChart.hiddenFields) {
            let column = {accessor: hiddenFieldItem.fieldName, show: false};
            columns[0].columns.push(column);
            fields.push(hiddenFieldItem.fieldName);
        }

        for (const entryItem of list.entries) {
            let addItem = false;

            if (searchText && searchText.length > 0) {
                for (const fieldItem of fields) {
                    if (
                        typeof entryItem[fieldItem] === "string" &&
                        entryItem[fieldItem]
                            .toLowerCase()
                            .indexOf(searchText.toLowerCase()) >= 0
                    ) {
                        addItem = true;
                        break;
                    }
                }
            } else {
                addItem = true;
            }

            if (addItem) {
                let listItem = {};
                for (const fieldItem of fields) {
                    listItem[fieldItem] = entryItem[fieldItem];
                }
                if (entryItem["lastBooking"] === true)
                    listItem["lastBooking"] = true;
                data.push(listItem);
            }
        }

        const tdStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    background: rowInfo.row._original.lastBooking === true ? "lightgrey" : ""
                }
            }
        };
        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    getTrProps={this.onRowClick}
                    getTdProps={tdStyle}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingFromList;
